import 'reflect-metadata';
import { BaseEntity } from '../../core/entities/base.entity';
import { Relation } from '../../core/decorators/relation.decorator';
import { RelationRef } from '../../core/types/entity-types';
import {
  LearningSectionContainerEntity
} from '../../learning-section/learning-section-container/learning-section-container-entity';

export class ExplanationContentEntity extends BaseEntity {
  name!: string;
  content!: string;

  version?: number;

  @Relation()
  learningSectionContainers?: RelationRef<LearningSectionContainerEntity>[];
}
